/**
 * @constructor
 * @returns {SpinReel}
 */
import {arrayCircleGetIndex} from "../utils/helpers";

export default function SpinReel() {

    /** @type {Game} */
    this._game;

    /** @type {number} */
    this.id;

    /** @type {GameConfig} */
    this._gameConfig;

    /** @type {SymbolsManager} */
    this._symbolsManager;

    /** @type {ReelPrinter} */
    this._printer;

    /** @type ReelMotion */
    this.motion;

    /** @type {Array<AbstractSymbol>} */
    this.symbols = []; //array of actual reel symbols (objects) //3lines => 5 symbols

    /** @type {Array<AbstractSymbol>} */
    this.spinSymbols = []; //array of all reel symbols (objects)

    /** @type {Array<AbstractSymbol>} */
    this.reelSymbols = []; //array of displyed symbols (3 lines -> 3 symbols)

    /** @type {Array<AbstractSymbol>} */
    this.tmpSymbols = []; //copy of reelsSymbols

    /** @type {Array<AbstractSymbol>} */
    this.failSymbols = [];

    this._allMatrix = []; //server_config.logic.reels
    this._reelMatrix = []; //server_config.matrix.reelMatrix;
    this._failMatrix = []; //server_config.logic.failResult

    this.symbolPosition = 0;

    this.shiftY = 0;
    this.spreaded = false;

    this.searching = false;

    this.forceStopping = false;
}

/**
 * @param {Game} game
 * @param {number} id
 * @param {GameConfig} gameCfg
 * @param {SymbolsManager} symbolsManager
 * @param {ReelPrinter} printer
 * @param {ReelMotion} motion
 * @returns {undefined}
 */
SpinReel.prototype.init = function(game, id, gameCfg, symbolsManager, printer, motion) {
    this._game = game;
    this.id = id;
    this._gameConfig = gameCfg;
    this._symbolsManager = symbolsManager;
    this._printer = printer;

    this.motion = motion;
};

SpinReel.prototype.setAllMatrix = function(symbolsNum) {
    this._allMatrix = symbolsNum;
};

SpinReel.prototype.getAllMatrix = function() {
    return this._allMatrix;
};

SpinReel.prototype.setReelMatrix = function(matrix) {
    this._reelMatrix = matrix;
};

SpinReel.prototype.getReelMatrix = function() {
    return this._reelMatrix;
};

SpinReel.prototype.setFailMatrix = function(matrix) {
    this._failMatrix = matrix;
};

SpinReel.prototype.getFailMatrix = function() {
    return this._failMatrix;
};

SpinReel.prototype.getFailSymbols = function() {
    return this.failSymbols;
};

SpinReel.prototype.setSymbolPosition = function(pos) {
    this.symbolPosition = pos ? pos : 0;
};

/**
 * @public
 * @returns {Array}
 */
SpinReel.prototype.getSpinSymbols = function() {
    return this.spinSymbols;
};

SpinReel.prototype.create = function(group) {

    this.createSpinSymbols(group);
    this.initReelSymbols(group);
    this.createReelSymbols();
    this.initSymbols();

    /*//this.createSpinSymbols();
    this.initReelSymbols(group);
    this.createReelSymbols();
    //
    //this.createTmpSymbols();
    this.initSymbols();*/
};

SpinReel.prototype.reinitPositions = function() {

    for(var i = 0; i < this.spinSymbols.length; i++) {
        this.spinSymbols[i].setPosY(-9999);
    }

    this._printer.print(this);
};

SpinReel.prototype.destroyReelSymbols = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].destroy();
    }
};

/**
 * Creates reels blurred symbols (not win symbols)
 * @param {MadnesGroup} group
 */
SpinReel.prototype.createSpinSymbols = function(group) {
    var i = this.id;
    var x = this._gameConfig.reelsPositions[i]["x"];

    for(var j = 0; j < this._allMatrix.length; j++) {

        var symbol = this._symbolsManager.create(this._allMatrix[j], x, -9999, i, j);
        symbol.setVisible(false);
        symbol.createBlurSymbol();

        group.add(symbol.getSprite());

        this.spinSymbols[j] = symbol;
    }
};

SpinReel.prototype.killSpinSymbols = function() {
    for(var i = 0; i < this.spinSymbols.length; i++) {
        this.spinSymbols[i].kill();
    }
};

SpinReel.prototype.reviveSpinSymbols = function() {
    for(var i = 0; i < this.spinSymbols.length; i++) {
        this.spinSymbols[i].revive();
    }
};

SpinReel.prototype.destroySpinSymbols = function() {
    for(var i = 0; i < this.spinSymbols.length; i++) {
        this.spinSymbols[i].destroy();
    }

    this.spinSymbols = [];
};

SpinReel.prototype.unblurSpinSymbols = function() {
    for(var i = 0; i < this.spinSymbols.length; i++) {
        this.spinSymbols[i].createSimpleSymbol();
    }
};

/*SpinReel.prototype.createTmpSymbols = function(group) {
	var i = this.id;
	var x = this._gameConfig.reelsPositions[i]["x"];

	if(this.spreaded) {

		this.tmpSymbols[0] = this._symbolsManager.create(
			10, x, -9999, i, 0, "reel_" + i + "_symbol_" + 0 + "_TMP"
		);
		this.tmpSymbols[0].setVisible(false);

		this.tmpSymbols[1] = this._symbolsManager.create(
			10, x, -9999, i, 1, "reel_" + i + "_symbol_" + 1 + "_TMP"
		);
		this.tmpSymbols[1].createSpreadBlurSymbol("center", true);
		//this.tmpSymbols[1].setVisible(false);
		//this.tmpSymbols[1].spreaded = true;

		this.tmpSymbols[2] = this._symbolsManager.create(
			10, x, -9999, i, 2, "reel_" + i + "_symbol_" + 2 + "_TMP"
		);
		this.tmpSymbols[2].setVisible(false);

	} else {

		for(var j = 0; j < this.reelSymbols.length; j++) {
			var y = this.reelSymbols[j].getPosY();

			this.tmpSymbols[j] = this._symbolsManager.create(
				this.reelSymbols[j].getSymbolNum(), x, y, i, j,
				"reel_" + i + "_symbol_" + j + "_TMP"
			);

			this.tmpSymbols[j].createBlurSymbol();
		}
	}

	for(var j = 0; j < 3; j++) {
		group.add(this.tmpSymbols[j].getSprite());
		this.tmpSymbols[j].temporary = true;
	}
};*/

SpinReel.prototype.setTmpSymbols = function() {
    for(var j = 0; j < this.reelSymbols.length; j++) {
        this.tmpSymbols.push(this.reelSymbols[j]);
    }
};

SpinReel.prototype.removeTmpSymbols = function() {

    //console.log(this.tmpSymbols[0], this.tmpSymbols[1], this.tmpSymbols[2]);

    for(var i = 0; i < this.tmpSymbols.length; i++) {
        this.tmpSymbols[i].destroy();
    }

    this.tmpSymbols.length = 0;
};

SpinReel.prototype.removeReelSymbols = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].destroy();
        this.reelSymbols[i] = null;
    }
};

SpinReel.prototype.removeHidedSymbols = function() {

    //this.destroySpinSymbols();
    this.killSpinSymbols();

    /*this.symbols[this.symbols.length - 1].destroy();
    this.symbols[this.symbols.length - 1] = null;

    this.symbols[0].destroy();
    this.symbols[0] = null;*/
};

SpinReel.prototype.stopStandAnim = function(symbols) {
    for(var i = 0; i < symbols.length; i++) {
        symbols[i].stopStandAnim();
    }
};

SpinReel.prototype.createShineAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].createShineAnim();
    }
};

SpinReel.prototype.stopShineAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].stopShineAnim();
    }
};

SpinReel.prototype.playShineAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].playShineAnim();
    }
};

SpinReel.prototype.fadeOutStandAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].fadeOutStandAnim();
    }
};

SpinReel.prototype.fadeInStandAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].fadeInStandAnim();
    }
};

SpinReel.prototype.initSymbols = function() {

    if(this.spinSymbols.length > 0) {
        this.symbols[0] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition)];
        this.symbols[0].setVisible(false);

        this.symbols[this.reelSymbols.length + 1] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition - 1)];
        this.symbols[this.reelSymbols.length + 1].setVisible(false);
    }

    for(var j = 0; j < this.reelSymbols.length; j++) {
        this.symbols[j + 1] = this.reelSymbols[j];
    }
};

SpinReel.prototype.initTmpSymbols = function() {

    if(this.spinSymbols.length > 0) {
        this.symbols[0] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition)];
        this.symbols[0].setVisible(false);

        this.symbols[this.reelSymbols.length + 1] = this.spinSymbols[arrayCircleGetIndex(this._allMatrix, this.symbolPosition - 1)];
        this.symbols[this.reelSymbols.length + 1].setVisible(false);
    }

    for(var j = 0; j < this.tmpSymbols.length; j++) {
        this.symbols[j + 1] = this.tmpSymbols[j];
    }
};

/**
 * Initializes reel symbols after result load
 * @param {MadnesGroup} group
 */
SpinReel.prototype.initReelSymbols = function(group) {
    var i = this.id;
    var x = this._gameConfig.reelsPositions[i]["x"];

    this.reelSymbols = [];

    for(var j = 0; j < this._reelMatrix.length; j++) {

        this.reelSymbols[j] = this._symbolsManager.create(this._reelMatrix[j], x, -9999, i, j);

        group && group.add(this.reelSymbols[j].getSprite());
    }
};

SpinReel.prototype.createReelSymbols = function() {
    for(var j = 0; j < this.reelSymbols.length; j++) {
        this.reelSymbols[j].createSymbol();
    }
};

SpinReel.prototype.createBlurSymbols = function(symbols) {
    for(var j = 0; j < symbols.length; j++) {
        symbols[j].createBlurSymbol();
    }
};

SpinReel.prototype.createBlurTmpSymbols = function(group) {
    //var i = this.id;
    //var x = this._gameConfig.reelsPositions[i]["x"];

    if(this.spreaded) {

        this.tmpSymbols[0].createBlurSymbol().setVisible(false);

        this.tmpSymbols[2].createBlurSymbol().setVisible(false);

        this.tmpSymbols[1].spreaded = true;
        this.tmpSymbols[1].createSpreadBlurSymbol("center", true);

        group.add(this.tmpSymbols[1].getSprite());

    } else {
        this.createBlurSymbols(this.tmpSymbols);
    }
};

SpinReel.prototype.start = function() {
    this.started = true;
    return this.motion.start();
};

SpinReel.prototype.stop = function() {
    this.started = false;
    return this.motion.stop();
};

SpinReel.prototype.addSymbolsToStop = function(count) {
    this.motion.addSymbolsToStop(count);
};

SpinReel.prototype.onSpin = function(func) {
    this.motion.onSpin(func);
};

SpinReel.prototype.onStop = function(func) {
    this.motion.onStop(func);
};

SpinReel.prototype.onBrakeDown = function(func) {
    this.motion.onBrakeDown(func);
};

SpinReel.prototype.onBrakeUp = function(func) {
    this.motion.onBrakeUp(func);
};

SpinReel.prototype.visibleReelSymbols = function(bool) {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].setVisible(bool);
    }
};

SpinReel.prototype.createAndPlayStandAnim = function() {

    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].createStandAnim();
        this.reelSymbols[i].playStandAnim();
    }
};

SpinReel.prototype.playStandAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].playStandAnim();
    }
};

SpinReel.prototype.clearSymbols = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].clear();
    }
};

SpinReel.prototype.createSymbols = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].createSymbol();
    }
};

SpinReel.prototype.createStandAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].createStandAnim();
    }
};

SpinReel.prototype.playStandAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {
        this.reelSymbols[i].playStandAnim();
    }
};

SpinReel.prototype.landAnim = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {

        if(typeof this.reelSymbols[i].createLandAnim !== 'undefined') {
            this.reelSymbols[i].createLandAnim();
            this.reelSymbols[i].playLandAnim();
        }
    }
};

SpinReel.prototype.hideInvisibleSymbols = function() {
    this.symbols[0].setVisible(false);
    this.symbols[this.symbols.length - 1].setVisible(false);
};

SpinReel.prototype.showInvisibleSymbols = function() {

    this.symbols[0].setVisible(true);
    this.symbols[this.symbols.length - 1].setVisible(true);
};

SpinReel.prototype.showSymbols = function() {
    this.symbols[0].setVisible(true);
    this.symbols[this.symbols.length - 1].setVisible(true);

    this.showReelSymbols();
};

SpinReel.prototype.showReelSymbols = function() {
    for(var i = 1; i < this.symbols.length -1; i++) {
        this._symbolsManager.showHideSymbol(this.symbols[i]);
    }
};

SpinReel.prototype.hasScatter = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {

        if(this.reelSymbols[i].symbolName === "symbol_Book") {
            return true;
        }
    }

    return false;
};

SpinReel.prototype.hasWild = function() {
    for(var i = 0; i < this.reelSymbols.length; i++) {

        if(this.reelSymbols[i].symbolName === "symbol_Alchemist") {
            return true;
        }
    }

    return false;
};